import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import FormInput from '@/components/forms/FormInput';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useTournamentTemplates from '@/hooks/useTournamentTemplates';
import { createTournament } from '@/redux/slices/tournaments';
import { FormProvider } from 'react-hook-form';
import { useFormStatusReducer } from '@/hooks/useFormStatusReducer';

const tournamentFormSchema = yup.object({
  templateId: yup.string().required('Template is required'),
});

const SnGModalForm = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useDispatch();
  const { tournamentTemplates } = useTournamentTemplates({ sng: true });

  const [formStatus, dispatchFormStatus] = useFormStatusReducer();

  const methods = useForm({
    resolver: yupResolver(tournamentFormSchema),
  });

  const onSubmit = (data: any) => {
    dispatch(
      createTournament({
        templateId: data.templateId,
        sng: true,
        meta: {
          toast: {
            success: 'Sit & Go created successfully',
            error: 'Failed to create tournament',
          },
        },
      }),
    );
    onClose();
  };

  return (
    <Modal isOpen toggle={onClose} id="create-tournament-template" className="modal-lg" centered>
      <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit(onSubmit)}>
          <ModalHeader>Create New Sit & Go</ModalHeader>
          <ModalBody style={{ maxHeight: '75vh' }} className="overflow-auto">
            <div className="w-100 d-flex flex-column justify-content-start max-h-[75vh] gap-2 overflow-auto">
              <div className="w-100 d-flex justify-content-between flex-row gap-2">
                <Col>
                  <Row className="w-100">
                    <Col>
                      <FormInput
                        control={methods.control}
                        label="Template"
                        name="templateId"
                        type="select"
                        options={tournamentTemplates?.map((template) => ({ value: template.id, label: template.name }))}
                      />
                    </Col>
                  </Row>
                </Col>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="grey" onClick={onClose}>
              Cancel
            </Button>
            <Button
              disabled={!methods.formState?.isValid || formStatus.isLoading}
              onClick={methods.handleSubmit(onSubmit)}
              color="primary"
            >
              {formStatus.isLoading ? 'Creating...' : 'Create New Tournament'}
            </Button>
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  );
};

export default SnGModalForm;
